import React from "react";

const Blog = () => {
  return (
    <div className="container mx-auto py-10">
      <h2 className="text-3xl font-bold text-center mb-6">Latest Blog Posts</h2>
      <p className="text-lg text-gray-700 text-center">
      Stay updated with the latest fashion trends, personalized shopping tips, and Quickfit insights. Coming soon!
      </p>
      {/* Add blog listing or articles preview */}
    </div>
  );
};

export default Blog;
